import {
  ArrowUpRight,
  BadgeDollarSign,
  Loader2,
  ReceiptText,
  TrendingDown,
  TrendingUp,
} from 'lucide-react';
import React from 'react';
import { useDashboardContext } from './DashboardContext';
import { formatMoney } from './helpers';

const KPICard: React.FC<{
  title: string;
  value: string;
  icon: React.ReactNode;
  isPositive: boolean;
  isLoading: boolean;
}> = ({ title, value, icon, isPositive, isLoading }) => (
  <div className="flex flex-col justify-between rounded-[22px] border border-slate-100 bg-white p-4 shadow-[0_2px_8px_rgba(0,0,0,0.02)]">
    <div className="flex items-center gap-2 text-[11px] font-medium text-slate-500">
      <div className="flex h-6 w-6 items-center justify-center rounded-full bg-slate-50 text-slate-400">
        {icon}
      </div>
      {title}
    </div>
    <div className="mt-3 text-xl font-bold tracking-tight text-slate-900 h-[28px] flex items-center">
      {isLoading ? (
        <Loader2 className="animate-spin text-slate-400" size={20} />
      ) : (
        value
      )}
    </div>
    <div className="mt-3 flex items-center gap-1.5">
      <span
        className={`flex items-center gap-0.5 rounded-md px-1.5 py-0.5 text-[10px] font-semibold ${
          isPositive
            ? 'bg-emerald-50 text-emerald-600'
            : 'bg-rose-50 text-rose-600'
        }`}
      >
        {isPositive ? <ArrowUpRight size={12} /> : <TrendingDown size={12} />}
        {isPositive ? '+' : '-'}~%
      </span>
      <span className="text-[9px] text-slate-400">vs last month</span>
    </div>
  </div>
);

export const MetricsRow: React.FC = () => {
  const { dashboard, loadingStates } = useDashboardContext();
  const isLoading = loadingStates.summary;
  return (
    <>
      <KPICard
        title="Gross Sales"
        value={formatMoney(dashboard.summary.grossSales)}
        isPositive
        icon={<TrendingUp size={12} />}
        isLoading={isLoading}
      />
      <KPICard
        title="Discounts"
        value={formatMoney(dashboard.summary.totalDiscounts)}
        isPositive={false}
        icon={<BadgeDollarSign size={12} />}
        isLoading={isLoading}
      />
      <KPICard
        title="Avg Bill"
        value={formatMoney(dashboard.summary.averageBill)}
        isPositive
        icon={<ReceiptText size={12} />}
        isLoading={isLoading}
      />
    </>
  );
};
